import axios from 'axios'
import qs from 'qs'
import { hexMd5 } from '@/api/md5'
import { Message } from 'element-ui'
//import { Message } from '@/api/jingxin-ui'
import store from '@/store/store'

// const url = 'https://q3388.com/api.n/index.php'
// const url = process.env.BASE_PATH
// const service = axios.create()

axios.interceptors.request.use(config => {

  let appCode = store.state.appCode
  let appVersion = store.state.appVersion
  let apiKey = store.state.apiKey
  const apiSign = hexMd5(appCode + ":" + appVersion + ":" + apiKey);
  config.headers["X-Api-Sign"]= apiSign
  config.headers["appCode"]= appCode
  config.headers["appVersion"]= appVersion
  
  if(!config.Reconnection){
    config.baseURL = sessionStorage.apiUrl || window.location.origin
  }
  if(!config.url.includes('domain_status')){
    if(config.method=='get'){
      let curl = config.baseURL + config.url
      let url = new URL(curl);
      let params = new URLSearchParams(url.search);
      // params.set('domain', location.host);
      params.set('cdomain', location.host);
      url.search = params;
      url.toString()
      config.url = url.pathname+url.search
    }else{
      // config.data.domain = location.host
      config.data.cdomain = location.host
    }
  }

  // console.log('config',config,config.data)
  // config.baseURL = 'http://abc.com'
  // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  return config
}, error => {
  Promise.reject(error)
})

axios.interceptors.response.use(response => {
  if(!response.config.url.includes('domain_status')){
    sessionStorage.apiUrl = response.config.baseURL || ''
  }
  return response
}, error => {
    if(error.config && yunweiConfig.apiUrl.length>0 && !error.config.url.includes('domain_status') ){
      let config = error.config
      let apiIndex = yunweiConfig.apiUrl.findIndex(x=>x==config.baseURL)
      if(apiIndex!=yunweiConfig.apiUrl.length-1){
        let url = new URL(config.url,config.baseURL || window.location.origin)
        let newConfig = Object.assign({},config)
          newConfig.baseURL = yunweiConfig.apiUrl[apiIndex+1]
          newConfig.url = url.pathname+url.search
          newConfig.Reconnection = true
        return axios(newConfig)
      }
    }
  return Promise.reject(error)
})
// export default service



// WEBPACK FOOTER //
// ./src/api/request.js